// extracted by mini-css-extract-plugin
export default {"emptyData":"empty-data___YdIoVXx"};